import React, { Suspense } from 'react';
import './App.css';
import NavBar from './components/navigation/navigation-bar';
import Container from 'react-bootstrap/esm/Container';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'leaflet/dist/leaflet.css';
import HomePage from './pages/home/HomePage';
import FSBOSellerDashboard from './pages/dashboard/fsbo';
import Footer from './components/footer/Footer';
import PropertyViewPage from './pages/property-view/PropertyViewPage';
import BookmarkedPropertiesPage from './pages/bookmarks/BookmarkedPropertiesPage';
import RenterProfilePage from './pages/profile/Profile';
import MessagesPage from './pages/messages/MessagesPage';
import BrowseListingsPage from './pages/browse-listings/BrowseListingsPage';
import LandlordDashboard from './pages/landlord-dashboard/LandlordDashboard';
import CreateListingPage from './pages/create-listing/CreateListingPage';
import ContinueDraftPage from './pages/continue-draft/ContinueDraftPage';
import CompleteListing from './pages/complete-listing/CompleteListing';
import MyListingsPage from './pages/manage-listings/MyListingsPage';
import EditListingPage from './pages/edit-listing/EditListingPage';
import CookiePolicy from './pages/cookie-policy/CookiePolicy';
import ContactPage from './pages/contact/ContactPage';
import TermsOfService from './pages/terms-of-service/terms-of-service';
import LandlordGuide from './pages/landlord-guide/LandlordGuide';
import RenterGuide from './pages/renter-guide/RenterGuide';
import AboutUs from './pages/about-us/about-us';
import PrivacyPolicy from './pages/privacy-policy/privacy-policy';
import DigitalServicesActPage from './pages/legal/DigitalServicesActPage';
import { Login } from './pages/login/login';
import { SignUp } from './pages/signup/signup';
import SuccessPage from './pages/success/SuccessPage';
import NotFoundPage from './pages/not-found-page/NotFoundPage';
import propertyToolsRoutes from './routes/propertyToolsRoutes';
import UserReviews from './components/user-reviews/UserReviews';
import ScrollToTop from './components/scroll-to-top/ScrollToTop';
import PropertyToolsGrid from './components/property/property-grid/PropertyToolsGrid';
import LandlordListingsPage from './pages/property-owner-listings/LandlordListingsPage';
import FAQPage from './pages/faqs/FAQPage';
import ThingsToDoPage from './pages/things-to-do/ThingsToDoPage';
import ThingsToDoLandingPage from './pages/things-to-do/ThingsToDoLandingPage';
import DataRequestPage from './pages/data-request/DataRequestPage';
import ProtectedRoute from './routes/ProtectedRoute';
import Blogs from './pages/blog/Blogs';
import FirestoreBlogReadPage from './pages/blog/FirestoreBlogReadPage';
import { useCookieConsent } from './context/CookieConsentContext';
import PropertyListingLandingPage from './pages/property-listing-landing-page/PropertyListingLandingPage';
import ErrorBoundary from './components/error-boundary/ErrorBoundary';
import marketingRoutesWithSuspense from './routes/marketingRoutes';
import { Toaster } from 'react-hot-toast';
import CookiePreferences from './components/cookie-preferences/CookiePreferences';
import NewsletterConfirmation from './pages/newsletter-confirmation/NewsletterConfirmation';
import BanCheckWrapper from './components/ban-check-wrapper/BanCheckWrapper';
import NewsletterUnsubscribe from './pages/newsletter-unsubscribe/NewsletterUnsubscribe';
import NewsletterPreferences from './pages/newsletter-preferences/NewsletterPreferences';
import EmailVerification from './pages/email-verification/EmailVerification';
import MarketingEmailVerification from './pages/email-verification/MarketingEmailVerification';
import SafetyPage from './pages/safety-page/SafetyPage';
import ReportListingPage from './pages/report-listing/ReportListingPage';
import HelpCenterPage from './pages/help-center/HelpCenterPage';
import OnboardingPage from './pages/onboarding-page/OnboardingPage';
import ExploreCategoriesPage from './pages/explore-categories/ExploreCategoriesPage';
import AutoApplyDashboard from './components/auto-apply/AutoApplyDashboard';
import AutoApplyFAQ from './components/auto-apply/AutoApplyFAQ';
import HowAutoApplyWorks from './components/auto-apply/HowAutoApplyWorks';
import SuccessStories from './components/auto-apply/SuccessStories';
import EmailTemplateForm from './pages/test-email-templates/EmailTemplateForm';
import { useAnalyticsWithConsent } from './hooks/useAnalyticsWithConsent';
import CookieConsentBanner from './components/cookie-consent/CookieConsent';
import BannedAccountPage from './pages/banned-account/BannedAccountPage';
import CommunityGuidelines from './pages/community-guidelines/CommunityGuidelines';
import LandlordToolkitPage from './pages/landlord-toolkit/LandlordToolkitPage';
import AddManagedPropertyPage from './pages/landlord-toolkit/AddManagedPropertyPage';
import AccessibilityStatementPage from './pages/accessibility-statement/AccessibilityStatementPage';
import AcceptTenancyInvitePage from './pages/accept-tenancy-invite/AcceptTenancyInvitePage';
import TenantOnboardingPage from './pages/tenant-onboarding/TenantOnboardingPage';
import TenantToolkitPage from './pages/tenant-toolkit/TenantToolkitPage';
import PropertyTenantsPage from './pages/property-tenants/PropertyTenantsPage';
import MaintenanceRequestsPage from './pages/maintenance-requests/MaintenanceRequestsPage';
import TenantMaintenancePage from './pages/maintenance-requests/TenantMaintenancePage';
import ReminderSettingsPage from './pages/landlord-toolkit/ReminderSettingsPage';
import ManagedPropertiesPage from './pages/landlord-toolkit/ManagedPropertiesPage';
import ManageViewingsPage from './pages/landlord-toolkit/ManageViewingsPage';
import LandlordToolkitDocs from './pages/landlord-toolkit/LandlordToolkitDocs';
import ExpensesPage from './pages/landlord-toolkit/ExpensesPage';
import CompliancePage from './pages/landlord-toolkit/CompliancePage';
import RentTrackerPage from './pages/rent-tracker/RentTrackerPage';
import RentReviewCalculatorPage from './pages/landlord-toolkit/RentReviewCalculatorPage';
import RentalResourcesLayoutPage from './pages/landlord-toolkit/RentalResourcesPage';
import LandlordToolkitMessagesPage from './pages/messages/LandlordToolkitMessagesPage';
import HomeValuationPage from './pages/home-valuation/HomeValuationPage';
import SellerChecklistPage from './pages/seller-checklist/SellerChecklistPage';
import PriceTrendsPage from './pages/prices/PriceTrendsPage';
import PriceTrendsDiscoverPage from './pages/prices/PriceTrendsDiscoverPage';
import LivingInArea from './pages/area-profile/LivingInArea';
import DiscoverAreasPage from './pages/area-profile/DiscoverAreasPage';
import LandlordRules2026 from './pages/blog/LandlordRules2026';
import TenantRights2026 from './pages/blog/IrishTenantRights2026';
import ManagedPropertySuccessPage from './pages/landlord-toolkit/ManagedPropertySuccessPage';
import RouteTracker from './components/analytics/RouteTracker';
import LandlordToolkitDashboard from './pages/landlord-toolkit/LandlordToolkitDashboard';
import CommunityPage from './pages/community/CommunityPage';
import ExplorePSEOPage from './pages/explore-pseo/ExplorePSEOPage';
import RentTrackerLandingPage from './pages/property-tools-landing/RentTrackerLandingPage';
import MortgageCalculatorLandingPage from './pages/property-tools-landing/MortgageCalculatorLandingPage';
import RentReviewCalculatorLandingPage from './pages/property-tools-landing/RentReviewCalculatorLandingPage';
import PropertyAlertsLandingPage from './pages/property-tools-landing/PropertyAlertsLandingPage';
import AffordabilityCalculatorLandingPage from './pages/property-tools-landing/AffordabilityCalculatorLandingPage';
import RentalYieldCalculatorLandingPage from './pages/property-tools-landing/RentalYieldCalculatorLandingPage';
import HousingReportDiscoverPage from './pages/housing-reports/HousingReportDiscoverPage';
import HousingCountyReportPage from './pages/housing-reports/HousingCountyReportPage';
import SalaryAfterTaxDiscoverPage from './pages/salary-after-tax/SalaryAfterTaxDiscoverPage';
import SalaryAfterTaxPage from './pages/salary-after-tax/SalaryAfterTaxPage';
import LandlordInsightsDiscoverPage from './pages/landlord-insights/LandlordInsightsDiscoverPage';
import LandlordCountyInsightsPage from './pages/landlord-insights/LandlordCountyInsightsPage';
import CostOfLivingDiscoverPage from './pages/cost-of-living/CostOfLivingDiscoverPage';
import CostOfLivingCountyPage from './pages/cost-of-living/CostOfLivingCountyPage';
import CityComparisonsDiscoverPage from './pages/city-comparisons/CityComparisonsDiscoverPage';
import CityComparisonPage from './pages/city-comparisons/CityComparisonPage';
import GoodSalaryDiscoverPage from './pages/good-salary/GoodSalaryDiscoverPage';
import GoodSalaryCountyPage from './pages/good-salary/GoodSalaryCountyPage';
import RentAffordabilityDiscoverPage from './pages/rent-affordability/RentAffordabilityDiscoverPage';
import RentAffordabilityDetailPage from './pages/rent-affordability/RentAffordabilityDetailPage';
import RentIncreaseNoticeDiscoverPage from './pages/rent-increase-notice/RentIncreaseNoticeDiscoverPage';
import RentIncreaseNoticeCountyPage from './pages/rent-increase-notice/RentIncreaseNoticeCountyPage';
import SchoolsAroundDiscoverPage from './pages/schools-around/SchoolsAroundDiscoverPage';
import SchoolsAroundDetailPage from './pages/schools-around/SchoolsAroundDetailPage';
import DublinCommuterDiscoverPage from './pages/dublin-vs-commuter/DublinCommuterDiscoverPage';
import DublinCommuterComparisonPage from './pages/dublin-vs-commuter/DublinCommuterComparisonPage';
import EvictionRightsDiscoverPage from './pages/eviction-rights/EvictionRightsDiscoverPage';
import EvictionRightsDetailPage from './pages/eviction-rights/EvictionRightsDetailPage';
import SelfBuildDiscoverPage from './pages/self-build/SelfBuildDiscoverPage';
import SelfBuildCostPage from './pages/self-build/SelfBuildCostPage';
import NewVsOldDiscoverPage from './pages/new-vs-old/NewVsOldDiscoverPage';
import NewVsOldDetailPage from './pages/new-vs-old/NewVsOldDetailPage';

const App = () => {
  const { consentStatus, updateConsentStatus, isConsentFormVisible } = useCookieConsent();

  const { grantPixelConsent, revokePixelConsent } = useAnalyticsWithConsent();

  const LoadingFallback = () => (
    <div className="flex justify-center items-center min-h-[400px]">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
    </div>
  );

  const handleAcceptCookies = () => {
    updateConsentStatus('accepted');
    // Initialize cookies or tracking here

    grantPixelConsent();
  };

  const handleRejectCookies = () => {
    updateConsentStatus('rejected');
    // Disable cookies or tracking here
    revokePixelConsent();
  };

  // PIXEL TRACKING USAGE
  // Track standard event (e.g., 'Purchase', 'Lead')
  // ReactPixel.track('Purchase', {
  //   currency: 'USD',
  //   value: 30.0
  // });

  // // Track a custom event
  // ReactPixel.trackCustom('ButtonClicked', {
  //   buttonName: 'SignUpButton'
  // });

  return (
    <>
      <BrowserRouter>
        <RouteTracker />
        <ScrollToTop />
        <NavBar />
        <Container>
          <ErrorBoundary>
            <Suspense fallback={<LoadingFallback />}>
              {/* Update the condition to show the banner */}
              {(consentStatus === null || isConsentFormVisible) && (
                <CookieConsentBanner
                  onAccept={handleAcceptCookies}
                  onReject={handleRejectCookies}
                />
              )}
              <Toaster position="top-right" />
              <BanCheckWrapper>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/signup" element={<SignUp />} />
                  <Route path="/discover-areas" element={<DiscoverAreasPage />} />
                  <Route path="/account-banned" element={<BannedAccountPage />} />
                  <Route path="/browse" element={<BrowseListingsPage />} />
                  <Route path="/housing-reports" element={<HousingReportDiscoverPage />} />
                  <Route path="/housing-reports/:county" element={<HousingCountyReportPage />} />
                  <Route path="/landlord-insights" element={<LandlordInsightsDiscoverPage />} />
                  <Route
                    path="/landlord-insights/:county"
                    element={<LandlordCountyInsightsPage />}
                  />
                  <Route path="/salary-after-tax" element={<SalaryAfterTaxDiscoverPage />} />
                  <Route
                    path="/salary-after-tax/:salarySlug"
                    element={<SalaryAfterTaxPage />}
                  />
                  <Route path="/affordability" element={<RentAffordabilityDiscoverPage />} />
                  <Route
                    path="/affordability/:affordabilitySlug"
                    element={<RentAffordabilityDetailPage />}
                  />
                  <Route path="/salary" element={<GoodSalaryDiscoverPage />} />
                  <Route path="/salary/:goodSalarySlug" element={<GoodSalaryCountyPage />} />
                  <Route path="/cost-of-living" element={<CostOfLivingDiscoverPage />} />
                  <Route path="/cost-of-living/:county" element={<CostOfLivingCountyPage />} />
                  <Route path="/city-comparisons" element={<CityComparisonsDiscoverPage />} />
                  <Route
                    path="/city-comparisons/:comparisonSlug"
                    element={<CityComparisonPage />}
                  />
                  <Route
                    path="/tools/rent-increase-notice-generator"
                    element={<RentIncreaseNoticeDiscoverPage />}
                  />
                  <Route
                    path="/tools/rent-increase-notice-generator-:county"
                    element={<RentIncreaseNoticeCountyPage />}
                  />
                  <Route
                    path="/tools/rent-increase-notice-generator/:county"
                    element={<RentIncreaseNoticeCountyPage />}
                  />
                  <Route path="/schools-around" element={<SchoolsAroundDiscoverPage />} />
                  <Route
                    path="/schools-around/:neighborhoodSlug"
                    element={<SchoolsAroundDetailPage />}
                  />
                  <Route
                    path="/compare/renting-in-dublin-vs-commuter-towns"
                    element={<DublinCommuterDiscoverPage />}
                  />
                  <Route
                    path="/compare/:comparisonSlug"
                    element={<DublinCommuterComparisonPage />}
                  />
                  <Route path="/rights" element={<EvictionRightsDiscoverPage />} />
                  <Route
                    path="/rights/:rightsSlug"
                    element={<EvictionRightsDetailPage />}
                  />
                  <Route path="/self-build" element={<SelfBuildDiscoverPage />} />
                  <Route
                    path="/self-build/:selfBuildSlug"
                    element={<SelfBuildCostPage />}
                  />
                  <Route path="/new-vs-old" element={<NewVsOldDiscoverPage />} />
                  <Route
                    path="/new-vs-old/:comparisonSlug"
                    element={<NewVsOldDetailPage />}
                  />
                  {/* pSEO Routes for long-tail intent searches (capture any extra filters) */}
                  <Route
                    path="/:intent(rent|sale|share)/:location/*"
                    element={<BrowseListingsPage />}
                  />
                  <Route path="/prices/:area" element={<PriceTrendsPage />} />
                  <Route path="/prices/discover" element={<PriceTrendsDiscoverPage />} />
                  <Route path="/onboarding" element={<OnboardingPage />} />
                  <Route path="/cookie-preferences" element={<CookiePreferences />} />
                  <Route path="/verify-email" element={<EmailVerification />} />
                  <Route
                    path="/verify-email-marketing"
                    element={<MarketingEmailVerification />}
                  />
                  {/* Newsletter routes */}
                  <Route path="/confirm-newsletter" element={<NewsletterConfirmation />} />
                  <Route
                    path="/newsletter-preferences"
                    element={
                      <ProtectedRoute>
                        <NewsletterPreferences />
                      </ProtectedRoute>
                    }
                  />
                  {/* Safety & Support Routes */}
                  <Route path="/safety" element={<SafetyPage />} />
                  <Route path="/report-listing" element={<ReportListingPage />} />
                  <Route path="/help-center" element={<HelpCenterPage />} />
                  <Route path="/explore-categories" element={<ExploreCategoriesPage />} />
                  <Route path="/explore-properties" element={<ExplorePSEOPage />} />
                  <Route path="/living-in/:area" element={<LivingInArea />} />
                  <Route path="/unsubscribe-newsletter" element={<NewsletterUnsubscribe />} />
                  <Route path="/list-your-property" element={<PropertyListingLandingPage />} />
                  <Route path="/blog" element={<Blogs />} />
                  <Route path="/blog/:id" element={<FirestoreBlogReadPage />} />
                  <Route
                    path="/profile"
                    element={
                      <ProtectedRoute>
                        <RenterProfilePage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/messages"
                    element={
                      <ProtectedRoute>
                        <MessagesPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/landlord-toolkit/messages"
                    element={
                      <ProtectedRoute>
                        <LandlordToolkitMessagesPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="/auto-apply" element={<AutoApplyDashboard />} />
                  <Route path="/auto-apply/how-it-works" element={<HowAutoApplyWorks />} />
                  <Route path="/auto-apply/success-stories" element={<SuccessStories />} />
                  <Route path="/auto-apply/faq" element={<AutoApplyFAQ />} />
                  <Route
                    path="/messages/:id"
                    element={
                      <ProtectedRoute>
                        <MessagesPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/landlord-dashboard"
                    element={
                      <ProtectedRoute>
                        <LandlordDashboard />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/landlord-dashboard/maintenance"
                    element={
                      <ProtectedRoute>
                        <MaintenanceRequestsPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/tenant/maintenance"
                    element={
                      <ProtectedRoute>
                        <TenantMaintenancePage />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="/landlord-toolkit/docs" element={<LandlordToolkitDocs />} />
                  <Route path="/landlord-toolkit" element={<LandlordToolkitPage />} />
                  <Route
                    path="/landlord-toolkit/dashboard"
                    element={<LandlordToolkitDashboard />}
                  />

                  <Route
                    path="/landlord-toolkit/add-property"
                    element={
                      <ProtectedRoute>
                        <AddManagedPropertyPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/landlord-toolkit/add-property/success"
                    element={
                      <ProtectedRoute>
                        <ManagedPropertySuccessPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/landlord-toolkit/reminders"
                    element={
                      <ProtectedRoute>
                        <ReminderSettingsPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/landlord-toolkit/managed-properties"
                    element={
                      <ProtectedRoute>
                        <ManagedPropertiesPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/landlord-toolkit/manage-viewings"
                    element={
                      <ProtectedRoute>
                        <ManageViewingsPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/landlord-toolkit/rent-tracker"
                    element={
                      <ProtectedRoute>
                        <RentTrackerPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/landlord-toolkit/rent-review-calculator"
                    element={
                      <ProtectedRoute>
                        <RentReviewCalculatorPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/landlord-toolkit/expenses"
                    element={
                      <ProtectedRoute>
                        <ExpensesPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/landlord-toolkit/compliance"
                    element={
                      <ProtectedRoute>
                        <CompliancePage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/test-email-templates"
                    element={
                      <ProtectedRoute>
                        <EmailTemplateForm />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="/add-listing" element={<CreateListingPage />} />
                  <Route
                    path="/continue-draft/:id"
                    element={
                      <ProtectedRoute>
                        <ContinueDraftPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/complete-listing"
                    element={
                      <ProtectedRoute>
                        <CompleteListing />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/listing-success"
                    element={
                      <ProtectedRoute>
                        <SuccessPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/property-owner-listings/:owner"
                    element={<LandlordListingsPage />}
                  />
                  <Route path="/property-tools" element={<PropertyToolsGrid />} />

                  {/* Property Tools Landing Pages */}
                  <Route
                    path="/property-tools/rent-tracker-landing"
                    element={<RentTrackerLandingPage />}
                  />
                  <Route
                    path="/property-tools/mortgage-calculator-landing"
                    element={<MortgageCalculatorLandingPage />}
                  />
                  <Route
                    path="/property-tools/rent-review-calculator-landing"
                    element={<RentReviewCalculatorLandingPage />}
                  />
                  <Route
                    path="/property-tools/property-alerts-landing"
                    element={<PropertyAlertsLandingPage />}
                  />
                  <Route
                    path="/property-tools/affordability-calculator-landing"
                    element={<AffordabilityCalculatorLandingPage />}
                  />
                  <Route
                    path="/property-tools/rental-yield-calculator-landing"
                    element={<RentalYieldCalculatorLandingPage />}
                  />

                  <Route path="/home-valuation" element={<HomeValuationPage />} />
                  <Route path="/valuation/co-:county" element={<HomeValuationPage />} />
                  <Route path="/valuation/eircode-:routingKey" element={<HomeValuationPage />} />
                  <Route path="/valuation/:town" element={<HomeValuationPage />} />

                  {/* Things To Do pSEO Routes */}
                  <Route path="/things-to-do" element={<ThingsToDoLandingPage />} />
                  <Route path="/things-to-do/:county" element={<ThingsToDoPage />} />

                  <Route path="/blog/irish-landlord-rules-2026" element={<LandlordRules2026 />} />
                  <Route path="/blog/irish-tenant-rights-2026" element={<TenantRights2026 />} />
                  <Route path="/seller-checklist" element={<SellerChecklistPage />} />
                  <Route
                    path="/dashboard/fsbo"
                    element={
                      <ProtectedRoute>
                        <FSBOSellerDashboard />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="/cookie-policy" element={<CookiePolicy />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/landlord-guide" element={<LandlordGuide />} />
                  <Route path="/renter-guide" element={<RenterGuide />} />
                  <Route path="/feedback" element={<UserReviews />} />
                  <Route path="/faqs" element={<FAQPage />} />
                  <Route path="/data-requests" element={<DataRequestPage />} />
                  <Route
                    path="/edit-listing/:id"
                    element={
                      <ProtectedRoute>
                        <EditListingPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/my-listings"
                    element={
                      <ProtectedRoute>
                        <MyListingsPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="/bookmarks" element={<BookmarkedPropertiesPage />} />
                  <Route path="/property/:listingId" element={<PropertyViewPage />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/digital-services-act" element={<DigitalServicesActPage />} />
                  <Route path="/about-us" element={<AboutUs />} />
                  <Route path="/terms-of-service" element={<TermsOfService />} />
                  <Route path="/community" element={<CommunityPage />} />
                  <Route path="/community-guidelines" element={<CommunityGuidelines />} />
                  <Route path="/accessibility-statement" element={<AccessibilityStatementPage />} />
                  <Route
                    path="/landlord-resources/rental-agreement-templates"
                    element={<RentalResourcesLayoutPage />}
                  />
                  <Route path="/accept-tenancy-invite" element={<AcceptTenancyInvitePage />} />
                  <Route
                    path="/tenant-onboarding"
                    element={
                      <ProtectedRoute>
                        <TenantOnboardingPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/tenant-toolkit"
                    element={
                      <ProtectedRoute>
                        <TenantToolkitPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/property/:propertyId/tenants"
                    element={
                      <ProtectedRoute>
                        <PropertyTenantsPage />
                      </ProtectedRoute>
                    }
                  />
                  {/* Dynamically Generated Property Utility Tools Routes */}
                  {propertyToolsRoutes.map((route) => (
                    <Route
                      key={route.path}
                      path={`/property-tools/${route.path}`}
                      element={<route.component />}
                    />
                  ))}
                  {/* Marketing-specific routes with SEO */}
                  {/* Dynamically map marketing routes */}
                  {marketingRoutesWithSuspense.map((route, index) => (
                    <Route key={index} path={route.path} element={route.element} />
                  ))}
                  {/* 404 Not Found Route */}
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </BanCheckWrapper>
            </Suspense>
          </ErrorBoundary>
        </Container>
        <Footer />
      </BrowserRouter>
    </>
  );
};

export default App;
